import { FormattedMessage } from "react-intl";
import { Platform } from "react-native";

export function ShareAndDownload() {
  if (Platform.OS === "web") {
    return (
      <FormattedMessage
        defaultMessage="Download QR Code"
        description="Download QR Code button title"
      />
    );
  }
  return (
    <FormattedMessage
      defaultMessage="Share QR Code"
      description="Share QR Code button title"
    />
  );
}
